import { createAction } from "redux-actions"

import { CLOSE_ERROR_NOTIFICATION } from "../constants/ActionTypes"

export const deleteErrorNotification = createAction(CLOSE_ERROR_NOTIFICATION)
